// extracted by mini-css-extract-plugin
export default {"root":"jDtgcndI","netValue":"OYqXxDUR","loss":"b5YQ7Hte"};